import { useQuery } from 'react-query';
import CardRelatorio from '../CardRelatorio';
import Valor from '../Valor';
import axios from 'axios';
import Skeleton from '../../../components/layout/Skeleton';
import HBox from '../../../components/layout/HBox';
import Botao from '../../../components/Botao';
import { useState } from 'react';
import { addDays, format } from 'date-fns';

const CardContasAVencer = () => {
  const [dias, setDias] = useState<7 | 30>(7);

  const q = useQuery(
    ['financeiroContasAVencer', dias],
    async () => {
      const hoje = format(new Date(), 'yyyy-MM-dd');
      const fim = format(addDays(new Date(), dias), 'yyyy-MM-dd');

      const qs = new URLSearchParams();
      qs.append('facts', 'valor_a_vencer,qtd_a_vencer');
      qs.append('filter', JSON.stringify({ data_inicio: hoje, data_fim: fim }));

      const res = await axios.get(
        '/api/relatorios/lancamento_financeiro?' + qs.toString(),
      );
      return res.data.result?.[0];
    },
    { refetchOnWindowFocus: false },
  );

  return (
    <CardRelatorio titulo="Contas a vencer">
      <HBox>
        <Botao
          variant={dias === 7 ? 'outline-primary' : 'outline-secondary'}
          onClick={() => setDias(7)}
        >
          7 dias
        </Botao>
        <Botao
          variant={dias === 30 ? 'outline-primary' : 'outline-secondary'}
          onClick={() => setDias(30)}
        >
          30 dias
        </Botao>
      </HBox>
      {q.isFetching ? (
        <Skeleton format="box" />
      ) : (
        <Valor
          valor={q.data?.valor_a_vencer ? +q.data.valor_a_vencer : 0}
          prepend="R$"
          digits={2}
          append={`(${q.data?.qtd_a_vencer ?? 0})`}
          valueSize="1.8rem"
          fractionSize="1.2rem"
        />
      )}
    </CardRelatorio>
  );
};

export default CardContasAVencer;
